import 'uni-pages';
import Vue from 'vue'
import Page from './demo/packageMall/goodsWaterfall.vue'
createPage(Page)